import { createSelector } from 'reselect';
import { cosAnnexeSelectors } from '../../cosAnnexe';

const defaultInitialValues = { MaxUseUom: '%' };

export const makeGetInitialValues = createSelector(cosAnnexeSelectors.getById, cosAnnexeById =>
  createSelector(cosAnnexeId => cosAnnexeById[cosAnnexeId], cosAnnexe => cosAnnexe || defaultInitialValues),
);
